<template>
    <button
        :disabled="disabled || loading"
        class="lg:inline-flex lg:justify-center"
    >
        <span class="flex items-center justify-center lg:pr-8">
            <span class="absolute inline-flex items-center lg:relative lg:pr-3">
                <span
                    class="inline-flex items-center transition-opacity"
                    :class="{ 'opacity-0': !loading }"
                >
                    <Icon
                        name="spinner-third-duotone"
                        class="animate-spin text-xl"
                    />
                </span>
            </span>

            <span :class="{ 'opacity-30 lg:opacity-100': loading }">
                <slot>Submit</slot>
            </span>
        </span>
    </button>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        loading: boolean;
        disabled?: boolean;
    }>(),
    {
        disabled: false,
    },
    a,
);
</script>
